var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "evaluator-avatar" }, [
    _vm.evaluatorId
      ? _c("div", { staticClass: "avatar avatar-sm" }, [
          _c("img", {
            staticClass: "avatar-img user",
            attrs: {
              src: _vm.avatarURL,
              alt: _vm.fullName,
              title: _vm.fullName,
            },
          }),
        ])
      : _c("div", [
          _c("img", {
            staticClass: "avatar-img bot",
            attrs: {
              src: require("@/ui/assets/img/robot.svg"),
              alt: _vm.fullName,
              title: _vm.fullName,
            },
          }),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }